export const isVVV = () => {
  const hostnames = [
    "app.creatorshield.com",
    "localhost",
    "app-cs-dashboardapp-dev.azurewebsites.net",
    "app-cs-dashboardapp-dist-prod.azurewebsites.net",
  ];
  return !hostnames.includes(window.location.hostname);
  // return true;
};
